/**
 * Takes existing URL and reloads it to a new estimate by the given code.
 * @param estimateCode
 */
import { getSessionData, setSessionData } from './storageHelper';

import { LOCAL_STORAGE_KEY } from '~/core/constants';

export const alertWhenExiting = (e: Event) => {
  if (getIsDirtyState()) {
    e.preventDefault();
    e.returnValue = true; // required for chrome to alert
  }
};

/**
 * Set is dirty in local storage.
 */
export const setIsDirtyState = (value: boolean) => {
  setSessionData(LOCAL_STORAGE_KEY.IS_DIRTY, value);
};

export const getIsDirtyState = (): boolean => {
  const isDirty = getSessionData<boolean>(LOCAL_STORAGE_KEY.IS_DIRTY);

  return isDirty ?? false;
};

export const gotoNewEstimate = (estimateCode: string, resetToRoot = false) => {
  setIsDirtyState(false);
  const url = new URL(document.location.href);

  if (resetToRoot) {
    url.pathname = '';
  }
  url.searchParams.delete(LOCAL_STORAGE_KEY.LOAD_ESTIMATE);
  url.searchParams.append(LOCAL_STORAGE_KEY.LOAD_ESTIMATE, estimateCode);
  document.location.href = url.toString();
};
